import { render, staticRenderFns } from "./UpdateWorkOrderChargesNewModal.vue?vue&type=template&id=9ff2fc2e&"
import script from "./UpdateWorkOrderChargesNewModal.vue?vue&type=script&lang=js&"
export * from "./UpdateWorkOrderChargesNewModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports